import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const MarginBot = styled('span')(({ theme }) => ({
  marginBottom: theme.spacing(1),
  display: 'inline-block',
}));

export const RlContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const RlIcon = styled('span')(({ theme }) => ({
  height: theme.spacing(2),
  width: theme.spacing(2),
  verticalAlign: 'text-bottom',
  marginRight: theme.spacing(0.5),
  display: 'inline-flex',
}));

export const DisplayScores = styled('div')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('xl')]: {
    flexDirection: 'column',
  },
}));

export const RlScore = styled('div')(({ theme }) => ({
  ...theme.typography.button,
  display: 'flex',
  alignItems: 'center',
}));

export const HideXSmall = styled('span')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'inherit',
  },
}));

export const RlRow = styled('div', {
  shouldForwardProp: (prop) => prop !== 'padLeft',
})(({ theme, padLeft }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  // PFM-2599 QA: assessments list header was rendering at content-width on md
  // screens. Force full width so filter chips/sort wrap the available space.
  width: '100%',
  // Only the first child (the title+chips column) should expand; the second
  // child is the ReportFab CREATE NEW button which must stay at its natural
  // width on the right. Using `:first-of-type` previously matched both the
  // <div> and the <button> (each is the first of its tag type) and stretched
  // the button to fill the row.
  '& > :first-child': {
    flex: 1,
    minWidth: 0,
  },
  ...(padLeft && {
    paddingLeft: theme.spacing(1),
  }),
}));
